import { useInject } from '@back-office/submerchant';
import { observer } from 'mobx-react';
import React, { PropsWithChildren } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { useTitle } from 'react-use';

const PrivateRoute = observer((props: PropsWithChildren<RouteProps>) => {
  const { children, ...rest } = props;
  const { isAuth, currentUser } = useInject((store) => store.auth);

  useTitle(`Sub Merchant | ${currentUser?.merchantName}`, {
    restoreOnUnmount: true,
  });

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuth ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
});

export default PrivateRoute;
